<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M8.05618625,13.0918C8.05618625,13.0918,15.23735625,6.08941,15.23735625,6.08941C15.62325625,5.71294,15.62325625,5.10118,15.23735625,4.72471C15.23735625,4.72471,10.69145625,0.282353,10.69145625,0.282353C10.30559625,-0.0941176,9.67500625,-0.0941176,9.28912625,0.282353C9.28912625,0.282353,0.76206825,8.59294,0.76206825,8.59294C0.37618565,8.96941,0.37618565,9.58118,0.76206825,9.95765C0.76206825,9.95765,6.01383625,15.0776,6.01383625,15.0776C6.01383625,15.0776,13.65615625,15.0776,13.65615625,15.0776C13.65615625,15.0776,13.65615625,15.0682,13.65615625,15.0682C14.17385625,15.0682,14.59735625,14.6447,14.59735625,14.1271C14.59735625,13.6094,14.17385625,13.1859,13.65615625,13.1859C13.65615625,13.1859,7.96206625,13.1859,7.96206625,13.1859C7.96206625,13.1859,8.05618625,13.0918,8.05618625,13.0918C8.05618625,13.0918,8.05618625,13.0918,8.05618625,13.0918C8.05618625,13.0918,8.05618625,13.0918,8.05618625,13.0918ZM6.01383625,13.1482C6.01383625,13.1482,2.04206625,9.27059,2.04206625,9.27059C2.04206625,9.27059,6.01383625,5.40235,6.01383625,5.40235C6.01383625,5.40235,9.98559625,9.27059,9.98559625,9.27059C9.98559625,9.27059,6.01383625,13.1482,6.01383625,13.1482C6.01383625,13.1482,6.01383625,13.1482,6.01383625,13.1482Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Eraser',
} as DefineComponent
</script>
